import { render } from "./CheckoutHoldOptionsCallout.vue?vue&type=template&id=21e1ba11"
import script from "./CheckoutHoldOptionsCallout.vue?vue&type=script&lang=js"
export * from "./CheckoutHoldOptionsCallout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__